import type { MouseEvent } from 'react'

/** The class that makes a surface of controls unselectable (index.css, `.cs-ui`). */
export const CONTROL_SURFACE = 'cs-ui'

const EDITABLE = 'input, textarea, [contenteditable=""], [contenteditable="true"]'

/**
 * onContextMenu for a surface of controls: a touch long-press opens no context
 * menu on it, as RunningText's words already do. Fields keep theirs (paste),
 * and a mouse right-click is left alone. Chrome reports a long-press's
 * contextmenu as a PointerEvent with pointerType "touch"; where a browser gives
 * no pointer type, nothing is blocked.
 */
export function suppressTouchContextMenu(e: MouseEvent<HTMLElement>): void {
  const target = e.target as Element | null
  if (target?.closest(EDITABLE)) return
  if ((e.nativeEvent as Partial<PointerEvent>).pointerType === 'touch') e.preventDefault()
}
